const eventHandler = {
    // 親子関係のあるチェックボックスをchangeイベントハンドラーで制御する
    handleCheckboxChangeInteractions: function (parentCheckboxClass, childCheckboxClass) {
        $(document).on("change", parentCheckboxClass, function () {
            $(childCheckboxClass).prop("checked", $(this).prop("checked"));
        });

        $(document).on("change", childCheckboxClass, function () {
            let allChecked = true;
            $(childCheckboxClass).each(function () {
                if (!$(this).prop("checked")) {
                    allChecked = false;
                    return false;
                }
            });
            $(parentCheckboxClass).prop("checked", allChecked);
        });
    }
};

window.eventHandler = eventHandler;
